import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

interface UsersGroupIconProps extends SvgIconProps {
  fillColor?: string;
}

export const UsersGroupIcon: FC<UsersGroupIconProps> = ({ fillColor = '#475569', ...props }) => {
  return (
    <SvgIcon
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill='none'
        d="M12.3058 20.3682C9.06684 20.3682 6.29984 19.8782 6.29984 17.9162C6.29984 15.9542 9.04884 14.2462 12.3058 14.2462C15.5448 14.2462 18.3118 15.9382 18.3118 17.8992C18.3118 19.8602 15.5628 20.3682 12.3058 20.3682Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill='none'
        d="M12.3058 11.4487C14.4318 11.4487 16.1558 9.7257 16.1558 7.5997C16.1558 5.4737 14.4318 3.74969 12.3058 3.74969C10.1798 3.74969 8.45585 5.4737 8.45585 7.5997C8.44985 9.7177 10.1598 11.4417 12.2788 11.4487H12.3058Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6955 10.3916C19.9325 10.0606 20.8445 8.93257 20.8445 7.58957C20.8445 6.18857 19.8515 5.01857 18.5295 4.74857"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill='none'
      />
      <path
        d="M19.2765 13.5444C21.0305 13.5444 22.5285 14.7334 22.5285 15.7954C22.5285 16.4204 22.0115 17.1014 21.2275 17.2854"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill='none'
      />
      <path
        d="M5.91714 10.3916C4.67914 10.0606 3.76714 8.93257 3.76714 7.58957C3.76714 6.18857 4.76114 5.01857 6.08214 4.74857"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill='none'
      />
      <path
        d="M5.33514 13.5444C3.58114 13.5444 2.08314 14.7334 2.08314 15.7954C2.08314 16.4204 2.60014 17.1014 3.38514 17.2854"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill='none'
      />
    </SvgIcon>
  )
}
